import * as React from "react";
import { MainContent } from "../../MainContent";
export class RenderMainHeading extends React.PureComponent {
    render() {
        const name = `${this.props.cms.ShowLivePhraseBeforeSportName ? this.props.dict.Live : ""} ${this.props.name} ${this.props.subName || ""}`;
        const eventsCount = this.props.cms.ShowSportEventsCount ? `(${this.props.eventsCountLength})` : "";
        const shouldExpand = this.props.renderedHeadings < this.props.cms.ExpandedMainGroupItems;
        const props = Object.assign(Object.assign({}, this.props), { name, eventsCount, shouldExpand });
        return (React.createElement(MainContent, Object.assign({ key: `sport-content-${this.props.id}` }, props), this.props.children));
    }
}
//# sourceMappingURL=RenderMainHeading.js.map